import { useIntl } from 'react-intl';

import { TextDocument } from '@sorare/core/src/routing/TextDocument/lazy';

import { InfoLayout } from '#src/components/layouts/InfoLayout.tsx';

const ApiTerms = () => {
  const { formatMessage } = useIntl();
  return (
    <InfoLayout>
      <TextDocument
        document={formatMessage({
          id: 'APITerms.path',
          defaultMessage: 'APITerms.md',
        })}
        skipHtml
      />
    </InfoLayout>
  );
};

export default ApiTerms;
